"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _market = require("@/api/market");
var _MarketDetail = _interopRequireDefault(require("@/components/MarketDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketList',
  components: {
    MarketDetail: _MarketDetail.default
  },
  data: function data() {
    return {
      collapse: false,
      labelPosition: 'right',
      listLoading: false,
      tableHeight: 0,
      searchForm: {
        marketName: '',
        environmentType: '',
        marketType: '',
        siteType: '',
        status: ''
      },
      tableFrom: {
        page: 1,
        limit: 10,
        marketName: '',
        environmentType: '',
        marketType: '',
        siteType: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      // 详情相关
      detailDrawerVisible: false,
      detailLoading: false,
      currentMarketDetail: null
    };
  },
  created: function created() {
    this.initList();
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.calculateTableHeight();
    });
    window.addEventListener('resize', this.calculateTableHeight);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    // 处理图片字符串数组
    getImageList: function getImageList(imageStr) {
      if (!imageStr) return [];
      if (typeof imageStr === 'string') {
        try {
          return JSON.parse(imageStr);
        } catch (error) {
          console.error('处理图片字符串失败:', error);
          return [];
        }
      }
      return Array.isArray(imageStr) ? imageStr : [];
    },
    // 获取第一张图片
    getFirstImage: function getFirstImage(imageStr) {
      var images = this.getImageList(imageStr);
      return images.length > 0 ? images[0] : '';
    },
    // 初始化列表
    initList: function initList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _market.marketList)(this.tableFrom).then(function (res) {
        console.log('res,', res);
        _this2.tableData.data = res.list || [];
        _this2.tableData.total = res.total || 0;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.tableData.data = [];
        _this2.tableData.total = 0;
        _this2.listLoading = false;
      });
    },
    // 搜索
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.tableFrom.marketName = this.searchForm.marketName;
      this.tableFrom.environmentType = this.searchForm.environmentType;
      this.tableFrom.marketType = this.searchForm.marketType;
      this.tableFrom.siteType = this.searchForm.siteType;
      this.tableFrom.status = this.searchForm.status;
      this.initList();
    },
    // 重置搜索
    handleReset: function handleReset(formName) {
      // 重置表单字段
      this.$refs[formName].resetFields();
      // 重置搜索表单数据
      this.searchForm = {
        marketName: '',
        environmentType: '',
        marketType: '',
        siteType: '',
        status: ''
      };
      // 重置查询参数
      this.tableFrom.page = 1;
      this.tableFrom.marketName = '';
      this.tableFrom.environmentType = '';
      this.tableFrom.marketType = '';
      this.tableFrom.siteType = '';
      this.tableFrom.status = '';
      // 重新加载列表
      this.initList();
    },
    // 新增
    handleAdd: function handleAdd() {
      this.$router.push({
        path: '/market/add'
      });
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.$router.push({
        path: '/market/add',
        query: {
          id: row.id
        }
      });
    },
    // 创建活动（带上当前集市）
    handleCreateActivity: function handleCreateActivity(row) {
      this.$router.push({
        path: '/market/activity/add',
        query: {
          marketId: row.id
        }
      });
    },
    // 上架
    handlePublish: function handlePublish(row) {
      var _this3 = this;
      this.$modal.confirm('确认上架该集市吗？').then(function () {
        (0, _market.marketPublish)({
          id: row.id
        }).then(function () {
          _this3.$message.success('上架成功');
          _this3.initList();
        });
      });
    },
    // 下架
    handlePullDown: function handlePullDown(row) {
      var _this4 = this;
      this.$modal.confirm('确认下架该集市吗？').then(function () {
        (0, _market.marketPullDown)({
          id: row.id
        }).then(function () {
          _this4.$message.success('下架成功');
          _this4.initList();
        });
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this5 = this;
      this.$modal.confirm('确认删除该集市吗？删除后不可恢复！').then(function () {
        (0, _market.marketDelete)(row.id).then(function () {
          _this5.$message.success('删除成功');
          _this5.initList();
        });
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.initList();
    },
    // 页码改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.tableFrom.page = val;
      this.initList();
    },
    // 获取集市属性名称
    getSiteTypeName: function getSiteTypeName(siteType) {
      var siteTypeMap = {
        1: '商圈',
        2: '社区',
        3: '公园',
        4: '场馆',
        5: '景区',
        6: '乐园',
        7: '展会'
      };
      return siteTypeMap[siteType] || '未知';
    },
    // 计算表格高度
    calculateTableHeight: function calculateTableHeight() {
      var _this6 = this;
      this.$nextTick(function () {
        var windowHeight = window.innerHeight;
        var headerHeight = _this6.$refs.tableheader ? _this6.$refs.tableheader.offsetHeight : 0;
        var paginationHeight = 60;
        var otherHeight = 200;
        _this6.tableHeight = windowHeight - headerHeight - paginationHeight - otherHeight;
      });
    },
    // 查看详情
    handleDetail: function handleDetail(row) {
      var _this7 = this;
      this.detailDrawerVisible = true;
      this.detailLoading = true;
      this.currentMarketDetail = null;
      (0, _market.marketInfo)(row.id).then(function (res) {
        console.log('详情数据:', res);
        _this7.currentMarketDetail = res;
        _this7.detailLoading = false;
      }).catch(function (err) {
        console.error('获取详情失败:', err);
        _this7.$message.error('获取详情失败');
        _this7.detailLoading = false;
      });
    },
    // 关闭详情抽屉
    handleDetailClose: function handleDetailClose() {
      this.detailDrawerVisible = false;
      this.currentMarketDetail = null;
    }
  }
};